
import React, { useEffect } from 'react';
import { BrowserRouter, Switch, Route, useHistory, NavLink } from 'react-router-dom';
import HeaderComponent from './components/header/header.component';
import NotFoundPage from './pages/not-found/not-found.page';
import HomePage from './pages/home/home.page';
import EventosPage from './pages/eventos/eventos.page';
import SnackComponent from './components/snack/snack.component';
import { GetCopiaService, GetSiteService } from './services/api-pages.service';
import { SnackService } from './services/snack.service';
import LoadingComponent from './components/loading/loading.component';
import { LoadingService } from './services/loading.service';
import SiteModel from './models/layout.model';
import MenuModel from './models/menu.model';
import { CONSTANTS } from './constants/constants';
import FooterComponent from './components/footer/footer.component';
import FooterModel from './models/footer.model';
import CookieConsent from 'react-cookie-consent';
import { Button } from '@mui/material';

function Routes() {

    const [listSite, setListSite] = React.useState<SiteModel>();
    const [menu, setMenu] = React.useState<MenuModel>();
    const [footer, setFooter] = React.useState<FooterModel>();

    let history = useHistory();

    useEffect(() => {
        var url_string = window.location.href;
        var url = new URL(url_string);
        var siteID = url.searchParams.get("siteID");
        var copiaID = url.searchParams.get("copiaID");

        if (copiaID) {
            GetCopia(copiaID);
            localStorage.setItem("siteID", copiaID)
        } else {
            if (window.location.href.indexOf('localhost') > -1 && !siteID) {
                siteID = '387';
                localStorage.setItem("siteID", '387')
            }

            GetSite(siteID);
        }
    }, [])

    const GetCopia = (id: string) => {
        LoadingService.sendLoadingAtivo(true);
        GetCopiaService({ ID: id }).then(res => {
            LoadingService.sendLoadingAtivo(false);
            if (res.data.error) {
                SnackService.sendMSG(res.data.error);
            } else {
                //setListSite(JSON.parse(res.data.json));
                //setMenu(JSON.parse(res.data.json).menu);
                //setFooter(JSON.parse(res.data.json).footer);
                setListSite(res.data);
                setMenu(res.data.menu);
                setFooter(res.data.footer);
            }
        }).catch(err => {
            SnackService.sendMSG('Erro com a conexão.');
            LoadingService.sendLoadingAtivo(false);
            console.log(err);
        });
    }

    const GetSite = (siteID: string | null) => {
        LoadingService.sendLoadingAtivo(true);
        GetSiteService({ ID: siteID ? siteID : localStorage.getItem("siteID") }).then(res => {
            LoadingService.sendLoadingAtivo(false);
            if (res.data.error) {
                SnackService.sendMSG(res.data.error);
            } else {
                if (res.data.copia_em_producao) {
                    GetCopia(res.data.copia_em_producao);
                    localStorage.setItem("siteID", res.data.copia_em_producao)
                } else {
                    setListSite(res.data);
                    setMenu(res.data.menu);
                    setFooter(res.data.footer);
                }
            }
        }).catch(err => {
            SnackService.sendMSG('Erro com a conexão.');
            LoadingService.sendLoadingAtivo(false);
            console.log(err);
        });
    }

    return (
        <BrowserRouter>
            {
                menu &&
                <HeaderComponent menu={menu} />
            }
            <Switch>
                {
                    menu?.tipo_menu === CONSTANTS.TIPO_MENU.SCROLL &&
                    <Route exact path="/" component={() => HomePage({ site: listSite, menu: menu, title: menu.nome_do_site })} />
                }

                {
                    menu?.tipo_menu === CONSTANTS.TIPO_MENU.NOVA_PAGINA &&
                    <>
                        {
                            menu.itens.map((itemMenu, iMenu) => (
                                <React.Fragment key={iMenu}>
                                    {
                                        !itemMenu.sem_acao &&
                                        <Route key={iMenu} exact
                                            path={"/" + itemMenu.id_do_componente}
                                            component={() => HomePage({ site: listSite, menu: menu, menuID: itemMenu.id, idDoComponente: itemMenu.id_do_componente, title: itemMenu.nome })} />
                                    }
                                </React.Fragment>
                            ))
                        }
                    </>
                }
                {/* <Route component={NotFoundPage} /> */}
            </Switch>
            {
                menu &&
                <FooterComponent footer={footer} menu={menu} />
            }
            <SnackComponent />
            <LoadingComponent />
            {
                listSite?.aviso_cookies?.aviso_cookies &&
                <CookieConsent
                    location="bottom"
                    buttonText={listSite?.aviso_cookies.legenda_botao_aceite}
                    cookieName="CookieConsent"
                    expires={150}
                >
                    {listSite?.aviso_cookies.texto}
                    <NavLink exact={true} to={listSite?.aviso_cookies.link_botao_politica} activeClassName="active">
                        <Button>{listSite?.aviso_cookies.legenda_botao_politica}</Button>
                    </NavLink>
                </CookieConsent>
            }
        </BrowserRouter>
    )
}

export default Routes;